import { ApiSmpGpt, FailureApi } from "@smp/api";
import { Await } from "@smp/utils";
import produce from "immer";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { useQueryGptAgentList } from "@/queries";

type Params = Parameters<typeof ApiSmpGpt.Agent.create>[0];
type Response = Await<ReturnType<typeof ApiSmpGpt.Agent.create>>;

export const useMutationGptAgentCreate = (
  options?: UseMutationOptions<Response, FailureApi, Params>,
) => {
  const queryClient = useQueryClient();

  return useMutation<Response, FailureApi, Params>(ApiSmpGpt.Agent.create, {
    ...options,
    onSuccess: (...args) => {
      queryClient.setQueriesData<
        ReturnType<typeof useQueryGptAgentList>["data"]
      >(useQueryGptAgentList.KEY, (data) =>
        produce(data, (draft) => {
          draft?.pages.at(0)?.results.unshift(args[0]);
        }),
      );

      options?.onSuccess?.(...args);
    },
  });
};
